import React, { useEffect, useRef } from 'react';
import { Star } from 'lucide-react';
const allTestimonials = [{
  quote: 'Desde que tengo el sistema 360, entro al aula sabiendo exactamente qué hacer. Mis alumnos participan mucho más y llego los lunes sin ese nudo en el estómago.',
  author: 'Valeria M.',
  details: '38 años · Córdoba'
}, {
  quote: 'Cuando empecé a usar este material me di cuenta de que el problema era el material anterior. Mis alumnos de 3° año ahora piden más clases de Salud. ¡Algo que nunca había pasado!',
  author: 'Romina G.',
  details: '44 años · Buenos Aires'
}, {
  quote: 'El sistema 360 me dio la estructura y el lenguaje justo para abordar todo sin incomodidad. La planificación anual me ahorró horas y horas de trabajo.',
  author: 'Sebastián T.',
  details: '36 años · Rosario'
}, {
  quote: 'Este es el mejor material que tuve en mis manos para esta materia. Está pensado para el aula real. Mis colegas me preguntan qué cambié porque notan la diferencia.',
  author: 'Marcela F.',
  details: '47 años · Mendoza'
}, {
  quote: 'Dejé de planificar los domingos a la noche. Las clases fluyen solas y los chicos están enganchados. Si estás dudando, no lo pienses más. Vale cada peso.',
  author: 'Laura P.',
  details: '33 años · La Plata'
}, {
  quote: 'Mis clases de Salud cambiaron completamente. Los chicos participan solos y se interesan genuinamente por los temas propuestos.',
  author: 'Carolina D.',
  details: '41 años · Tucumán'
}, {
  quote: 'Lo mejor que compré en años. Todo listo, sin vueltas. Me solucionó la planificación de todo el año en un solo clic.',
  author: 'Diego R.',
  details: '35 años · Mar del Plata'
}, {
  quote: 'Ojalá lo hubiera tenido antes. Me ahorra horas cada semana que ahora puedo dedicar a mi familia en lugar de planificar.',
  author: 'Florencia S.',
  details: '39 años · Santa Fe'
}, {
  quote: 'Material de primera. Mis colegas me piden que les pase el dato porque notan el cambio en la actitud de mis alumnos.',
  author: 'Gustavo A.',
  details: '42 años · Salta'
}, {
  quote: 'Por fin un recurso pensado para el aula real argentina. El lenguaje, los ejemplos, todo está perfectamente adaptado a nuestra realidad.',
  author: 'Natalia V.',
  details: '37 años · Neuquén'
}];
const row1 = allTestimonials.slice(0, 5);
const row2 = allTestimonials.slice(5, 10);
function TestimonialCard({
  testimonial
}: {
  testimonial: (typeof allTestimonials)[0];
}) {
  return <div className="bg-brand-card p-5 rounded-xl border border-white/5 flex flex-col min-w-[280px] md:min-w-[320px] w-[280px] md:w-[320px] flex-shrink-0" data-id="element-177">
      <div className="flex gap-0.5 mb-3" data-id="element-178">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-brand-accent" fill="currentColor" data-id="element-179" />)}
      </div>
      <p className="text-gray-300 italic text-sm leading-relaxed flex-grow mb-4 line-clamp-4 font-body" data-id="element-180">
        "{testimonial.quote}"
      </p>
      <div className="pt-3 border-t border-white/10" data-id="element-181">
        <p className="font-heading font-bold text-white text-sm" data-id="element-182">
          {testimonial.author}
        </p>
        <p className="text-xs text-gray-500 font-body" data-id="element-183">{testimonial.details}</p>
      </div>
    </div>;
}
function ScrollRow({
  testimonials,
  direction
}: {
  testimonials: typeof allTestimonials;
  direction: 'left' | 'right';
}) {
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animationId: number;
    const speed = direction === 'right' ? 0.5 : -0.5;
    const animate = () => {
      if (el) {
        el.scrollLeft += speed;
        if (direction === 'right' && el.scrollLeft >= el.scrollWidth - el.clientWidth) {
          el.scrollLeft = 0;
        }
        if (direction === 'left' && el.scrollLeft <= 0) {
          el.scrollLeft = el.scrollWidth - el.clientWidth;
        }
      }
      animationId = requestAnimationFrame(animate);
    };
    animationId = requestAnimationFrame(animate);
    const pause = () => cancelAnimationFrame(animationId);
    const resume = () => {
      animationId = requestAnimationFrame(animate);
    };
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    return () => {
      cancelAnimationFrame(animationId);
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', resume);
    };
  }, [direction]);
  const items = [...testimonials, ...testimonials];
  return <div ref={scrollRef} className="flex gap-4 overflow-x-hidden py-2" style={{
    scrollbarWidth: 'none',
    msOverflowStyle: 'none'
  }} data-id="element-184">
      {items.map((t, idx) => <TestimonialCard key={idx} testimonial={t} data-id="element-185" />)}
    </div>;
}
export function Testimonials() {
  return <section id="testimonios" className="py-16 bg-brand-dark overflow-hidden" data-id="element-186">
      <div className="max-w-6xl mx-auto px-4 mb-10" data-id="element-187">
        <div className="text-center" data-id="element-188">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3 uppercase" data-id="element-189">
            Lo que dicen otros docentes
          </h2>
          <p className="text-lg text-brand-accent italic font-bold font-body" data-id="element-190">
            Resultados reales en aulas argentinas
          </p>
        </div>
      </div>

      <div className="space-y-4" data-id="element-191">
        <ScrollRow testimonials={row1} direction="right" data-id="element-192" />
        <ScrollRow testimonials={row2} direction="left" data-id="element-193" />
      </div>
    </section>;
}